// extracted by mini-css-extract-plugin
export default {"container":"phnumber_container__xJdBU","box":"phnumber_box__ignGD","Number":"phnumber_Number__65YwU","call":"phnumber_call__yzKiK"};